import { createInlineStyleButton } from '@draft-js-plugins/buttons';
import { Icon } from '@sb1/ffe-icons-react';
import formatItalicIcon from '@sb1/ffe-icons/icons/open/300/md/format_italic.svg';
import formatBoldIcon from '@sb1/ffe-icons/icons/open/300/md/format_bold.svg';
import { Tooltip } from '../tooltip/Tooltip';

const BoldButton = createInlineStyleButton({
    style: 'BOLD',
    children: (
        <>
            <Icon fileUrl={formatBoldIcon} ariaLabel="bold text" />
        </>
    ),
});
const ItalicButton = createInlineStyleButton({
    style: 'ITALIC',
    children: (
        <>
            <Icon fileUrl={formatItalicIcon} ariaLabel="italic text" />
        </>
    ),
});

function FormatTextItems(props) {
    return (
        <>
            <Tooltip text="Fet">
                <BoldButton {...props} />
            </Tooltip>
            <Tooltip text="Kursiv">
                <ItalicButton {...props} />
            </Tooltip>
        </>
    );
}

export default FormatTextItems;
